import { modals } from '@mantine/modals';

import { useShowResponseStatus } from '@/shared';
import { useDeletePaymentMethodMutation } from '../store/payment-methods-api';
import { handlePaymentMethodDeleteError } from '../utils/helpers/payment-methods-errors';

import type { TPaymentMethod } from '../store/types';

export const useDeletePaymentMethod = () => {
  const [deletePaymentMethod, { isLoading, isSuccess, error }] = useDeletePaymentMethodMutation();
  const deleteError = handlePaymentMethodDeleteError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Платёжный метод успешно удалён',
    error: deleteError,
  });

  const handleDeleteModal = (item: TPaymentMethod) =>
    modals.openConfirmModal({
      title: `Удаление метода с ID ${item.id}`,
      centered: true,
      children: `Вы точно хотите удалить метод "${item.key} (${item.name})"?`,
      labels: { confirm: 'Удалить', cancel: 'Отмена' },
      confirmProps: { color: 'red' },
      onConfirm: async () => await deletePaymentMethod({ methodId: item.id }),
    });

  return {
    isLoading,
    handleDeleteModal,
    // deletePaymentMethod,
  };
};
